export const searchDropdown =  [
	{
	  title: "Order Type Name",
	  value: "name"
	},
	{
	  title: "Order Type Code",
	  value: "code"
	}
]



// WEBPACK FOOTER //
// ./src/pages/orderType/filter/searchDropdown.js